module.exports = __webpack_public_path__ + "assets/2factor-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/2factor-icon.svg
// module id = 220
// module chunks = 0